import { render, staticRenderFns } from "./AdminUserCategories.vue?vue&type=template&id=e0871678&"
import script from "./AdminUserCategories.vue?vue&type=script&lang=js&"
export * from "./AdminUserCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports